/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

// tslint:disable-next-line: class-name
export interface eventModel {
  type: string;
  event?: any;
}

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  private listerners = new Subject<eventModel>();

  constructor() {}

  listenEvent(): Observable<eventModel> {
    return this.listerners.asObservable();
  }

  setEvent(event: eventModel) {
    this.listerners.next(event);
  }
}
